import { render, staticRenderFns } from "./Transfers.vue?vue&type=template&id=2a9e3580&"
import script from "./Transfers.vue?vue&type=script&lang=js&"
export * from "./Transfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports